import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGoUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13.25 9a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .553 1.257l-5.5 6a.75.75 0 0 1-1.033.07l-2.57-2.142-4.034 2.689a.75.75 0 1 1-.832-1.248l4.5-3a.75.75 0 0 1 .896.048l2.45 2.042 3.865-4.216H14a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 3.75a8.25 8.25 0 0 0-7.566 11.544.75.75 0 1 1-1.375.6A9.728 9.728 0 0 1 2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75a9.713 9.713 0 0 1-4.334-1.014.75.75 0 1 1 .668-1.343A8.25 8.25 0 1 0 12 3.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorGoUp;
